import { motion } from "framer-motion";
import { X } from "lucide-react";
import { BeforeYouSleepCard } from "@/components/BeforeYouSleep";

// End of a talk: what we talked about, the one takeaway, then the firm plan for tonight and tomorrow.
export default function TalkWrapCard({ wrap, onClose, overlay }) {
  const body = (
    <div className="space-y-4" data-testid="talk-wrap">
      <div className="rounded-3xl border border-white/10 bg-card/70 p-5 sm:p-6">
        <p className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">What we talked about</p>
        <p className="mt-2 leading-relaxed" data-testid="talk-wrap-summary">{wrap.summary}</p>
        <p className="text-[10px] uppercase tracking-[0.22em] text-primary mt-5">Take this with you</p>
        <p className="font-serif text-xl sm:text-2xl leading-snug mt-1" data-testid="talk-wrap-takeaway">“{wrap.takeaway}”</p>
      </div>
      <BeforeYouSleepCard plan={wrap} compact />
    </div>
  );
  if (!overlay) return <div className="mt-2 mb-4">{body}</div>;
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 z-[90] bg-background/85 backdrop-blur-xl flex items-end sm:items-center justify-center p-4 overflow-y-auto" data-testid="talk-wrap-overlay">
      <motion.div initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.5 }} className="relative w-full max-w-md pt-10">
        <button onClick={onClose} aria-label="Close" className="absolute top-0 right-0 w-9 h-9 rounded-full bg-white/10 flex items-center justify-center" data-testid="talk-wrap-close"><X className="w-4 h-4" /></button>
        <p className="font-serif text-2xl mb-4">{wrap.coach} has set your night</p>
        {body}
      </motion.div>
    </motion.div>
  );
}
